import { GlobalAxios } from "./../axios/axios-config";
import {
  INewIntegrationRuleMov,
  IIntegrationRuleMov,
} from "../models/integration-rule-mov";

const INTEGRATION_RULE_MOVS_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleMov/";

export const createIntegrationRuleMov = (item: INewIntegrationRuleMov) => {
  return GlobalAxios.post(INTEGRATION_RULE_MOVS_ROUTE, item);
};

export const getIntegrationRuleMovById = (id: string) => {
  return GlobalAxios.get<IIntegrationRuleMov>(INTEGRATION_RULE_MOVS_ROUTE + id);
};

export const updateIntegrationRuleMovById = ({
  item,
  id,
}: {
  item: INewIntegrationRuleMov;
  id: string;
}) => {
  return GlobalAxios.put(INTEGRATION_RULE_MOVS_ROUTE + id, item);
};
